import { BlackFridayPromotion } from '../black-friday/promotion'
import { ChristmasOfferPromotion } from '../christmas/promotion'
import { useCampaigns } from '../state/hooks'
import { Campaigns } from '../state/types'

const promotionsMap: Record<Campaigns, React.FC> = {
  [Campaigns.Christmas]: ChristmasOfferPromotion,
  [Campaigns.BlackFriday]: BlackFridayPromotion,
}

export const CurrentCampaignPromotion = () => {
  const { activeCampaign } = useCampaigns()

  if (!activeCampaign || !promotionsMap[activeCampaign]) {
    return null
  }

  const PromotionComponent = promotionsMap[activeCampaign]

  return (
    <div className="flex items-center gap-3 flex-1 justify-center">
      <PromotionComponent />
    </div>
  )
}
